<template lang="pug">
#push_user_credit_card_modal_wrapper
  b-modal#push-user-credit-card(title='クレジットカードを追加',size="lg",'hide-footer')
    alert-error(v-if="error",:msg="error_msg")
    card-form(:stripe_key="stripe_key", @submit_form="pushNewCard")
  b-modal#push-user-credit-card-success(title='カード追加完了','hide-footer')
    p カード情報が送信されました。完了までお待ちください
</template>

<script>
import { mapState } from 'vuex'

import { required, url } from 'vuelidate/lib/validators'

import Vue from 'vue'

import CardForm from '../card_form.vue'

import AlertError from '../../components/parts/error.vue'

export default {
  data(){
    return {
      form_url: this.user_host,
      error: false,
      error_msg: ""
    }
  },
  props: {
    stripe_key: String,
    redirect_path: String,
  },
  methods: {
    async pushNewCard(token){
      this.error = false
      try{
        console.log("token", token)
        await this.$store.dispatch("user/pushCard", token.id)
        this.$bvModal.hide('push-user-credit-card')
        location.href = this.redirect_path
      } catch(e) {
        console.log(e)
        console.log(e.response)
        this.error = true
        this.error_msg = e.response.data.error
      }
      this.$store.commit("user/offSubmittingCard")

    },
  },
  components: {
    CardForm,
    AlertError
  },
  async mounted(){
    await Vue.nextTick()
    this.$store.commit("user/sethideChangeLabel", true)
  },
}
</script>
<style lang="scss" scoped>
</style>
